import React, { useEffect, useCallback } from 'react';
import { connect, useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import OperationalComponent from './operational';
import { actions as personnelActions } from '../Modules/dataGridTable';
import { getPersonnelDetailsTransformed } from '../Selectors/personnelSelectors';
import BaseDetails from 'containers/Base/BaseDetails';
import { closeDetails, openDetails, toggleModal } from 'reducers/ui';

import staticText from 'static/text_display.json';
import {
  translatedKeyValueText,
  languageConverter,
} from 'utils/methods/helpers';
import { personnelNS } from '../';
import { PAGE_URLS } from 'utils/constants';

const PersonnelDetails = ({
  toggleEditMode,
  toggleModal,
  canBeEdited,
  personnel,
  fetchPersonnelDetails,
  id,
  cancel,
  resetPersonnelDetail,
  // shiftList,
  resetPersonnelID,
  loading,
  setPersonnelID,
}) => {
  const dispatch = useDispatch();
  const dispatchOpenDetails = useCallback(
    url => {
      dispatch(openDetails(url));
    },
    [dispatch],
  );
  const dispatchCloseDetails = useCallback(
    url => {
      dispatch(closeDetails(url));
    },
    [dispatch],
  );
  useEffect(() => {
    if (id) {
      fetchPersonnelDetails({ id: id });
      dispatchOpenDetails(PAGE_URLS.PERSONNEL.link);
      setPersonnelID(id);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);
  const onEdit = () => {
    toggleEditMode();
    toggleModal(personnelNS);
  };

  const languageConvertedAssetDetail = personnel => {
    return languageConverter({
      details: personnel,
      arrayOfKeys: ['role'],
    });
  };

  const cancelled = () => {
    cancel();
    // remove details
    resetPersonnelDetail();
    // remove selected map id
    resetPersonnelID();

    dispatchCloseDetails(PAGE_URLS.PERSONNEL.link);
  };
  return (
    <BaseDetails
      loading={loading}
      editable={canBeEdited}
      header={staticText.managerial_view.personnel.details}
      details={languageConvertedAssetDetail(personnel)}
      onEdit={onEdit}
      cancel={cancelled}
      operationComponent={<OperationalComponent />}
      editHoverText={
        Object.keys(personnel).length > 0
          ? translatedKeyValueText('edit_value_title', {
              value: personnel.generalInfo.employeeId.value,
            })
          : staticText.managerial_view.personnel.edit_default
      }
    />
  );
};

PersonnelDetails.propTypes = {
  toggleEditMode: PropTypes.func,
  toggleModal: PropTypes.func,
  canBeEdited: PropTypes.bool,
  id: PropTypes.string.isRequired,
  cancel: PropTypes.func.isRequired,
  personnel: PropTypes.object,
  fetchPersonnelDetails: PropTypes.func,
  shiftList: PropTypes.array,
  resetPersonnelID: PropTypes.func,
  resetPersonnelDetail: PropTypes.func,
  setPersonnelID: PropTypes.func,
  loading: PropTypes.bool,
};

const mapStateToProps = state => ({
  personnel: getPersonnelDetailsTransformed(state),
  //canBeEdited: checkEditable(state),
  // shiftList: getShiftList(state),
});

const mapDispatchToProps = dispatch => ({
  toggleModal: personnelNS => dispatch(toggleModal(personnelNS)),
  fetchPersonnelDetails: ({ id, shiftId }) =>
    dispatch(personnelActions.fetchGridRowDetails({ id, shiftId })),
  resetPersonnelDetail: () => dispatch(personnelActions.setGridRowDetails({})),
  resetPersonnelID: () => dispatch(personnelActions.setSelectedRowID(null)),
  setPersonnelID: id => dispatch(personnelActions.setSelectedRowID(id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(PersonnelDetails);
